export const catalogRouteBase = (route = {}) => {
  const campanhaUrl = route?.params?.urlPromocao;

  if (campanhaUrl) {
    return {
      name: "catalogoCampanhaRota",
      params: { urlPromocao: campanhaUrl },
    };
  }

  return {
    name: "catalogoRota",
    params: {},
  };
};

export const buildCatalogRoute = (route = {}, query = {}) => {
  const { name, params } = catalogRouteBase(route);
  const sanitizedQuery = { ...query };

  delete sanitizedQuery.campanhaId;

  return {
    name,
    params,
    query: sanitizedQuery,
  };
};
